import styled from "grabcad-ui-elements";

export const Container = styled.div`
    width: 810px;
    margin: 10px auto;
    font-family: "Open Sans", Arial, sans-serif;
`;

export const InfoText = styled.div`
    color: #5c5c5c;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 10px;
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    padding: 12px 16px;
    margin-bottom: 10px;
    border-radius: 6px;
`;

export const Label = styled.div`
    font-family: "Inter", sans-serif;
    font-size: 14px;
    color: #333;

    span {
        color: #5c5c5c;
        margin-left: 5px;
    }
`;

interface ToggleProps {
    active: boolean;
}

export const Toggle = styled.div<ToggleProps>`
    width: 32px;
    height: 16px;
    background: ${(props) => (props.active ? "#003393" : "#858585")};
    border-radius: 100px;
    position: relative;
    cursor: pointer;
    transition: 0.3s;

    &::after {
        content: "";
        width: 12px;
        height: 12px;
        background: #ffffff;
        border-radius: 50%;
        position: absolute;
        top: 2px;
        left: ${(props) => (props.active ? "18px" : "2px")};
        transition: 0.3s;
    }
`;
